/* eslint-disable @next/next/no-img-element */
import { FragmentMediaUnionFragment } from '@/utils/drupal-api/__generated__/graphql';
import { ImageSrcSetSize } from '@/utils/image';
import clsx from 'clsx';

import DrupalImage from '../ui/drupal-image';
import { RemoteVideo } from './paragraph/remote_video';

export type MediaUnionComponentProps = {
  data: FragmentMediaUnionFragment;
  className?: string;
  figureClassName?: string;
  imageClassName?: string;
  imageSizes?: ImageSrcSetSize[];
  imageAspect?: number;
  noLoader?: boolean;
};

export const MediaUnionComponent: React.FC<MediaUnionComponentProps> = ({
  data,
  className,
  figureClassName,
  imageClassName,
  imageSizes,
  imageAspect,
  noLoader,
}) => {
  // @TOTO: Implement addtional __typenames for document and audio
  let captionClassName = clsx(
    'ut-sm mt-1.5 px-4 text-gray-7 md:px-0 text-center'
  );
  switch (data.__typename) {
    case 'MediaImage':
      switch (data.captionAlignment) {
        case 'left':
          captionClassName = clsx(captionClassName, 'text-left');
          break;
        case 'right':
          captionClassName = clsx(captionClassName, 'text-right');
          break;
      }
      break;
    // No caption for video or remote video
    case 'MediaVideo':
    case 'MediaRemoteVideo':
      break;
  }
  return (
    <section className={className}>
      {data.__typename == 'MediaImage' &&
        !data.mediaImage.url.includes('.svg') && (
          <figure className={figureClassName}>
            <DrupalImage
              image={data.mediaImage}
              className={imageClassName}
              srcsetSizes={imageSizes}
              aspect={imageAspect}
              noLoader={noLoader}
            />
            {data.caption && (
              <figcaption className={captionClassName}>
                {data.caption}
              </figcaption>
            )}
          </figure>
        )}
      {data.__typename == 'MediaImage' &&
        data.mediaImage.url.includes('.svg') && (
          <figure>
            <img
              className={imageClassName}
              src={data.mediaImage.url}
              alt={data.mediaImage.alt || ''}
            />
            {data.caption && <figcaption>{data.caption}</figcaption>}
          </figure>
        )}
      {(data.__typename === 'MediaVideo' ||
        data.__typename === 'MediaRemoteVideo') && (
        <figure>
          <RemoteVideo
            data={data}
            className={className}
            srcSetSizes={imageSizes}
            aspect={imageAspect}
          />
        </figure>
      )}
    </section>
  );
};

export default MediaUnionComponent;
